module.exports = __webpack_public_path__ + "img/zhang-ing.38fa43d4.png";